'use client';

import { VaultsPageHero } from 'src/components/Vaults/VaultsPageHero';
import { VaultsTables } from 'src/components/Vaults/VaultsTables';
import { ListYourVaultBanner } from '../../../components/Vaults/ListYourVaultBanner';

export default function VaultsPage() {
	return (
		<div className={'flex justify-center text-text-default'}>
			<div className="w-full max-w-[1272px] px-md pt-3xl sm:px-8">
				<div className="flex flex-col items-end gap-y-3xl sm:min-h-[100vh]">
					<VaultsPageHero />
					<VaultsTables />
				</div>
				<ListYourVaultBanner className="sticky bottom-0" />
			</div>
		</div>
	);
}
